import { render, staticRenderFns } from "./CustomerPasswordRequireChange.vue?vue&type=template&id=761a83ff&"
import script from "./CustomerPasswordRequireChange.vue?vue&type=script&lang=ts&"
export * from "./CustomerPasswordRequireChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports